// Consultas auxiliares para selectores y resolución de nombres (FK → etiqueta).
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { api } from "./api.ts";
import type { Row } from "./resource.ts";

export interface Stage {
  id: string; name: string; probability: number;
  stageType: "open" | "closed_won" | "closed_lost"; color: string; sortOrder: number;
}
export interface Pipeline { id: string; name: string; isDefault: boolean; stages: Stage[]; }

export function usePipelines() {
  return useQuery<{ pipelines: Pipeline[] }>({
    queryKey: ["pipelines"],
    queryFn: () => api.get("/pipelines"),
    staleTime: 300_000,
  });
}

// Selectores/mapas de nombres: trae hasta 100 (tope del servidor). Con más
// volumen conviene un buscador tipo typeahead (pendiente).
export function useAccounts() {
  return useQuery<{ rows: Row[]; total: number }>({
    queryKey: ["lookup", "accounts"],
    queryFn: () => api.get("/accounts?pageSize=100"),
    staleTime: 60_000,
  });
}

/** Mapa id → account_name para resolver FKs en deals/quotes. */
export function useAccountNames(): Map<string, string> {
  const accounts = useAccounts();
  return useMemo(() => {
    const m = new Map<string, string>();
    for (const a of accounts.data?.rows ?? []) {
      m.set(String(a["id"]), String(a["accountName"] ?? ""));
    }
    return m;
  }, [accounts.data]);
}

export function useContacts() {
  return useQuery<{ rows: Row[]; total: number }>({
    queryKey: ["lookup", "contacts"],
    queryFn: () => api.get("/contacts?pageSize=100"),
    staleTime: 60_000,
  });
}
